import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'report-stat',
    },
    selector: 'ndt-report-parameter-list',
    styleUrls: ['./report-parameter-list.component.scss'],
    templateUrl: './report-parameter-list.component.html',
    standalone: false
})
// eslint-disable-next-line @typescript-eslint/naming-convention
export class ReportParameterListComponent<P> {
   @Input() name: string;

   @Input() shortenedListCutoff = 5;

   @Input() all: boolean;

   @Input()
   set parameters(parameters: P[] | null) {
      this._parameters = parameters;
      this.parametersList = parameters?.join(', ');
   }

   get parameters(): P[] | null {
      return this._parameters;
   }

   private _parameters: P[] | null = null;

   parametersList: string | undefined;
}
